<template>
  <b-container v-if="verified">
    <Loading v-if="isLoading" :active.sync="isLoading"></Loading>
    <b-card class="page-body" body-class="has-footer">
      <CRow>
        <CCol xm="12" class="d-flex justify-content-center mb-4">
          <img class="header-img" src="../../assets/images/logo-indocyber.png">
        </CCol>
      </CRow>
      <CRow>
        <CCol xm="12" class="d-flex justify-content-center my-2">
          <h1 class="page-greetings">
            OCR STNK
          </h1>
        </CCol>
      </CRow>
      <CRow>
        <CCol xm="12" class="d-flex justify-content-center my-2">
          <h4 class="greetings-underline">
          </h4>
        </CCol>
      </CRow>
      <div class="content">
        <CRow>
          <div class="col-12">
            <label class="textarea-input">Input Image:</label>
            <input ref="fileupload" class="mb-2 sm-input" type="file" accept="image/png, image/jpeg" @change="onChooseImage">
          </div>
          <div class="form-button col-12" style="display: flex">
            <div class="toggle-flex" style="display: flex; align-items: center;">
              <label class="mr-1">Scanned Image:</label>
              <b-form-checkbox v-model="isScan" name="check-button" switch/>
            </div>
            <div class="sm-nav-wrapper" style="margin-left: auto">
              <div class="bottom-router">
                <router-link :to="{}" @click.native="onClickSubmit" class="btn">
                  <span><img src=""></span>Submit
                </router-link>
              </div>
            </div>
          </div>
          <div class="col-12">
            <label v-if="showPreview" class="textarea-input">Preview Image:</label>
            <b-img v-if="showPreview" :src="imagePreview" class="preview-image mb-2"></b-img>
          </div>
        </CRow>
      </div>
      <CRow v-if="keywords.length > 0">
        <CCol xm="12" class="d-flex justify-content-center my-2">
          <h4 class="greetings-underline">
            RESPONSE DATA
          </h4>
        </CCol>
      </CRow>
      <b-img v-if="fileResult.length > 0" :src=fileResult class="preview-image-response mb-4"></b-img>
      <div v-if="keywords.length > 0" class="content">
        <CRow>
          <div class="col-12">
            <b-table small
              :fields="fields"
              :items="keywords"
            >
              <template #cell(confidence)="row">
                <b-badge v-if="row.value.badge == 'Good'" variant="success">{{row.value.badge}} - {{row.value.percentage}} %</b-badge>
                <b-badge v-else variant="danger">{{row.value.badge}} - {{row.value.percentage}} %</b-badge>
              </template>
              <template #cell(index)="row">
                {{ row.index + 1 }}
              </template>
            </b-table>
          </div>
        </CRow>
      </div>
      <TheFooter></TheFooter>
    </b-card>
      <Modal v-if="showErrorModal" :foreground="true" :closeButton="false">
        <div slot="body">
          <label>{{errorLabel}}</label>
          <div class="btn-footer">
            <button class="btn-submit white" @click="showErrorModal = false">
              Tutup
            </button>
          </div>
        </div>
      </Modal>
  </b-container>
</template>
<script>
import TheFooter from  '../TheFooter';
import Modal from  '../Modal';
import moment from 'moment';

export default {
  name: 'Main',
  components: {
    TheFooter,
    Modal
  },
  data(){
    return {
      verified: false,
      isLoading: false,
      showErrorModal: false,
      // showOfficeModal: false,
      // showDaytimeModal: false,
      // showClocktimeModal: false,
      errorLabel: "Terjadi kesalahan pada server. Silahkan coba lagi.",
      errorReload: false,
      inputText: "",
      fields: [
          { key: 'label', label: 'Label' },
          { key: 'value', label: 'Value' },
          { key: 'confidence', label: 'Confidence' },
      ],
      keywords: [],
      fileResult: "",
      categoryMap: [],
      imagePreview: null,
      showPreview: false,
      base64: "",
      file: null,
      isScan: false,
      // serviceId: "",
      // serviceName: "",
      // customerId: "",
      // contractNo: "",
      // servOfficeCode: "",
      // workDayBook: 1,
      // officeOptions: [],
      // daytimeOptions: [],
      // clocktimeOptions: [],
      // selectedOffice: {},
      // selectedDaytime: {},
      // selectedClocktime: {}

      sample_response: {"success":true,"message":"STNK berhasil di proses","data":{"nomor_registrasi":{"value":"E 3472 WAB ","confidence":0.9866666666666667},"nama_pemilik":{"value":"BOBI AULIA SYAFIQ ","confidence":0.9966666666666667},"alamat":{"value":"KARANGTENGAH CLUSTER FRAMUKA CIANJUR REGENCY BLOKEDS NUMBERO- ","confidence":0.9714285714285715},"merk":{"value":"HONDA ","confidence":1},"type":{"value":"X1H02N35M1 A/T ","confidence":0.995},"jenis":{"value":"SEPEDA MOTOR ","confidence":1},"model":{"value":"SEPEDA MOTOR ","confidence":1},"tahun_pembuatan":{"value":"2019","confidence":1},"isi_silinder":{"value":"149 CC ","confidence":0.895},"nomor_rangka":{"value":"MH1KF4115KK705996","confidence":0.995},"nomor_mesin":{"value":"KF41E1708686","confidence":1},"warna":{"value":"HITAM ","confidence":1},"bahan_bakar":{"value":"BENSIN","confidence":1},"warna_tnkb":{"value":"HITAM","confidence":1},"tahun_registrasi":{"value":"2019","confidence":1},"nomor_bpkb":{"value":"P07918292","confidence":0.98},"kode_lokasi":{"value":"10700","confidence":1},"berlaku_sampai":{"value":"06 Nov 2024 ","confidence":1}},"image_path":"./output\\bobi_aulia_syafiq_9_jpg_combine.jpg","url":"http://10.10.131.108:8000/download_file/bobi_aulia_syafiq_9_jpg_combine.jpg"}
    }
  },
  methods: {
    onClickSubmitTest(){
      let raw = this.sample_response
      console.log(raw)
      let entries = []
      for (const [key, value] of Object.entries(raw.data)){
        let result = "Good"
        if(value.confidence < 0.9){
          result = "Bad"
        }
        entries.push({label: key, value: value.value, confidence: {"badge": result, "percentage": (value.confidence * 100).toFixed(2)}})
      }
      this.keywords = entries
      this.fileResult = raw.url
    },
    onChooseImage(e){
      this.keywords = []
      this.fileResult = []
      var file = e.target.files[0]
      if(file){
        this.file = e.target.files[0]
        this.imagePreview = URL.createObjectURL(file)
        // this.createBase64Image(file)
        this.showPreview = true
      }
    },
    createBase64Image(FileObject) {
      const reader = new FileReader();
      reader.onloadend = () => {
        this.base64 = reader.result.split(",")[1];
      }
      reader.readAsDataURL(FileObject);
    },
    onClickSubmit(){
      this.isLoading = true
      // let processUrl = "https://ktp.ocr.dev.inergi.id/api-stnk/recognize_vehicle_documents"
      let processUrl = "https://validation.demo.inergi.id/api/api-stnk/recognize_vehicle_documents"
      let data = new FormData()
      data.set('image', this.file)
      if(this.isScan){
        data.set('image_scan', 'true')
      } else {
        data.set('image_scan', 'false')
      }
      this.$axios.post(processUrl, data).then((response) => {
        if (response.status === 200){
          let raw = response.data
          if(raw.success) {
            let entries = []
            for (const [key, value] of Object.entries(raw.data)){
              let result = "Good"
              if(value.confidence < 0.9){
                result = "Bad"
              }
              entries.push({label: key, value: value.value, confidence: {"badge": result, "percentage": (value.confidence * 100).toFixed(2)}})
            }
            this.keywords = entries
            this.fileResult = "https://ktp.ocr.dev.inergi.id/api-stnk"+raw.url
          } else {
            this.errorLabel = raw.message
            this.errorReload = false
            this.showErrorModal = true
          }
        }
        else {
          this.errorLabel = "Terjadi kesalahan pada server. Silahkan coba lagi."
          this.errorReload = false
          this.showErrorModal = true
          return
        }
      })
      .catch(error => {
        // if(error.response) this.errorLabel = error.response.data.reason
        if(error.response){
          if(error.response.status == "401"){
            this.errorLabel = "API Key tidak valid atau sudah tidak berlaku. Mohon menghubungi tim untuk kode akses baru."
            this.$cookies.remove("api-key-stnk")
            delete this.$axios.defaults.headers.post['API-Key']
          }
          else{
            if(error.response.data && error.response.data.reason) this.errorLabel = error.response.data.reason
            else this.errorLabel = "Terjadi kesalahan pada server. Silahkan coba lagi."
          }
        }
        else this.errorLabel = "Terjadi kesalahan pada server. Silahkan coba lagi."
        this.errorReload = false
        this.showErrorModal = true
      })
      .finally(() => {
        this.isLoading = false
      })
    }
  },
  async mounted() {
    // this.$axios.defaults.headers.post['Content-Type'] = 'application/json';
    // this.$axios.post(processUrl, data, { headers: {"Content-Type": "multipart/form-data"} }).then((response) => {
    let res = ""
    if(this.$cookies.get("api-key-stnk")){
      res = this.$cookies.get("api-key-stnk")
      this.$axios.defaults.headers.post['API-Key'] = res
      this.$axios.defaults.headers.get['API-Key'] = res
      this.verified = true
    }
    else{
      while(!res) res = window.prompt("Please enter your access key.", "")
      while(!this.verified){
        // await this.$axios.post("http://10.10.131.108:9000/auth/validate-key", null, { headers: {"API-Key": res} }).then(_ => {
        await this.$axios.post("https://validation.demo.inergi.id/api/auth/validate-key", null, { headers: {"API-Key": res} }).then(_ => {
          this.$cookies.set("api-key-stnk", res)
          this.$axios.defaults.headers.post['API-Key'] = res
          this.$axios.defaults.headers.get['API-Key'] = res
          this.verified = true
        })
        .catch(error => {
          if(error.response){
            if(error.response.status == "401"){
              res = ""
              while(!res) res = window.prompt("Key validation failed. Please enter your access key.", "")
            }
            else{
              res = ""
              while(!res) res = window.prompt("Network error during verification. Please enter your access key.", "")
            }
          }
          else{
            res = ""
            while(!res) res = window.prompt("Network error during verification. Please enter your access key.", "")
          }
        })
      }
    }
  },
}
</script>